export const header = 'Λίστα Ανατεθημένων Χειρουργείων';
